import React from 'react';

const chipIconProps = {
  viewBox: '0 0 40 40',
  width: 16,
  height: 16,
  fill: 'currentColor',
  'aria-hidden': true as const,
};

export const LineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...chipIconProps}>
    <path d="M37.5639 13.5578C38.1454 12.9764 38.1454 12.0199 37.5639 11.4385C36.9825 10.8571 36.026 10.8571 35.4446 11.4385L23.0008 23.8824L15.0581 15.9397C14.4767 15.3583 13.5202 15.3583 12.9388 15.9397L2.43605 26.4424C1.85465 27.0238 1.85465 27.9803 2.43605 28.5617C3.01745 29.1431 3.97395 29.1431 4.55535 28.5617L13.9984 19.1186L21.9411 27.0613C22.5225 27.6427 23.479 27.6427 24.0604 27.0613L37.5639 13.5578Z" />
  </svg>
);

export const CandleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...chipIconProps}>
    <path d="M21.6364 3.63636C21.6364 2.73636 20.9 2 20 2C19.1 2 18.3636 2.73636 18.3636 3.63636V8.54545C18.3636 8.57614 18.3636 8.59659 18.3636 8.62727C16.492 9.00568 15.0909 10.6523 15.0909 12.6364V20.8182C15.0909 22.8023 16.5023 24.4489 18.3636 24.8273C18.3636 24.858 18.3636 24.8784 18.3636 24.9091V29.8182C18.3636 30.7182 19.1 31.4545 20 31.4545C20.9 31.4545 21.6364 30.7182 21.6364 29.8182V24.9091C21.6364 24.8784 21.6364 24.858 21.6364 24.8273C23.508 24.4489 24.9091 22.8023 24.9091 20.8182V12.6364C24.9091 10.6523 23.4977 9.00568 21.6364 8.62727C21.6364 8.59659 21.6364 8.57614 21.6364 8.54545V3.63636ZM6.90909 5.27273C6.00909 5.27273 5.27273 6.00909 5.27273 6.90909V11.8182C5.27273 11.8489 5.27273 11.8693 5.27273 11.9C3.40114 12.2784 2 13.925 2 15.9091V27.3636C2 29.3477 3.41136 30.9943 5.27273 31.3727C5.27273 31.4034 5.27273 31.4239 5.27273 31.4545V36.3636C5.27273 37.2636 6.00909 38 6.90909 38C7.80909 38 8.54545 37.2636 8.54545 36.3636V31.4545C8.54545 31.4239 8.54545 31.4034 8.54545 31.3727C10.417 30.9943 11.8182 29.3477 11.8182 27.3636V15.9091C11.8182 13.925 10.4068 12.2784 8.54545 11.9C8.54545 11.8693 8.54545 11.8489 8.54545 11.8182V6.90909C8.54545 6.00909 7.80909 5.27273 6.90909 5.27273ZM21.6364 12.6364V20.8182C21.6364 21.2682 21.2682 21.6364 20.8182 21.6364H19.1818C18.7318 21.6364 18.3636 21.2682 18.3636 20.8182V12.6364C18.3636 12.1864 18.7318 11.8182 19.1818 11.8182H20.8182C21.2682 11.8182 21.6364 12.1864 21.6364 12.6364ZM32.2727 21.6364H33.9091C34.3591 21.6364 34.7273 22.0045 34.7273 22.4545V27.3636C34.7273 27.8136 34.3591 28.1818 33.9091 28.1818H32.2727C31.8227 28.1818 31.4545 27.8136 31.4545 27.3636V22.4545C31.4545 22.0045 31.8227 21.6364 32.2727 21.6364ZM31.4545 18.3636C31.4545 18.3943 31.4545 18.4148 31.4545 18.4455C29.583 18.8239 28.1818 20.4705 28.1818 22.4545V27.3636C28.1818 29.3477 29.5932 30.9943 31.4545 31.3727C31.4545 31.4034 31.4545 31.4239 31.4545 31.4545V36.3636C31.4545 37.2636 32.1909 38 33.0909 38C33.9909 38 34.7273 37.2636 34.7273 36.3636V31.4545C34.7273 31.4239 34.7273 31.4034 34.7273 31.3727C36.5989 30.9943 38 29.3477 38 27.3636V22.4545C38 20.4705 36.5886 18.8239 34.7273 18.4455C34.7273 18.4148 34.7273 18.3943 34.7273 18.3636V13.4545C34.7273 12.5545 33.9909 11.8182 33.0909 11.8182C32.1909 11.8182 31.4545 12.5545 31.4545 13.4545V18.3636ZM7.72727 15.0909C8.17727 15.0909 8.54545 15.4591 8.54545 15.9091V27.3636C8.54545 27.8136 8.17727 28.1818 7.72727 28.1818H6.09091C5.64091 28.1818 5.27273 27.8136 5.27273 27.3636V15.9091C5.27273 15.4591 5.64091 15.0909 6.09091 15.0909H7.72727Z" />
  </svg>
);

export const AreaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...chipIconProps}>
    <path
      d="M4 6a1 1 0 0 0-2 0v24a6 6 0 0 0 6 6h28a1 1 0 0 0 0-2H8a4 4 0 0 1-4-4V6zm32 7a1 1 0 0 1 0 2l-9 9a2 2 0 0 1-3 0l-6-6-7 7a1 1 0 0 1-2 0l8-8a2 2 0 0 1 3 0l6 6 10-10z"
      fillOpacity=".4"
    />
    <path d="M37.5639 13.5578C38.1454 12.9764 38.1454 12.0199 37.5639 11.4385C36.9825 10.8571 36.026 10.8571 35.4446 11.4385L23.0008 23.8824L15.0581 15.9397C14.4767 15.3583 13.5202 15.3583 12.9388 15.9397L2.43605 26.4424C1.85465 27.0238 1.85465 27.9803 2.43605 28.5617C3.01745 29.1431 3.97395 29.1431 4.55535 28.5617L13.9984 19.1186L21.9411 27.0613C22.5225 27.6427 23.479 27.6427 24.0604 27.0613L37.5639 13.5578Z" />
  </svg>
);

export const BarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...chipIconProps}>
    <rect x="10.9999" y="8.00024" width="3" height="30" rx="1.5" />
    <rect x="26.0001" y="2" width="3" height="30" rx="1.5" />
    <rect
      x="19.9999"
      y="13.9998"
      width="3"
      height="9"
      rx="1.5"
      transform="rotate(90 19.9999 13.9998)"
    />
    <rect
      x="28.9999"
      y="4.99976"
      width="3"
      height="9"
      rx="1.5"
      transform="rotate(90 28.9999 4.99976)"
    />
    <rect
      x="14"
      y="29"
      width="3"
      height="9"
      rx="1.5"
      transform="rotate(90 14 29)"
    />
    <rect
      x="35.0001"
      y="20"
      width="3"
      height="9"
      rx="1.5"
      transform="rotate(90 35.0001 20)"
    />
  </svg>
);

/**
 * Eraser-style icon. Mirrors `packages/design-system/.../icons/clear.svg`
 * which the original chart uses for the "Clear All Charts" button.
 */
export const ClearIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...chipIconProps}>
    <path d="M37.5252 4.84905L27.958 14.4162L28.8021 15.3307C30.2794 16.808 30.5608 18.9888 29.576 20.7474L20.6419 36.8569C20.2198 37.5603 19.446 37.9824 18.6722 37.9824C18.0391 37.9824 17.4763 37.7714 17.0542 37.3493L2.63312 22.9282C2.21104 22.5061 2 21.9433 2 21.3102C2 20.5364 2.42208 19.7626 3.12555 19.3405L19.235 10.4064C20.9936 9.42159 23.1744 9.70298 24.6517 11.1803L25.5662 12.0244L35.1334 2.5276C35.7665 1.82413 36.8217 1.82413 37.5252 2.5276C38.1583 3.16072 38.1583 4.21593 37.5252 4.84905ZM24.722 22.5061L17.4763 15.2604L6.08012 21.5916L8.33122 23.8427L12.1299 22.6468C12.6224 22.4358 13.0445 22.8578 12.9038 23.3503L11.6375 27.149L18.3908 33.9023L24.722 22.5061Z" />
  </svg>
);

const strokeIconProps = {
  viewBox: '0 0 16 16',
  width: 16,
  height: 16,
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true as const,
};

const fillIconProps = {
  viewBox: '0 0 40 40',
  width: 16,
  height: 16,
  fill: 'currentColor',
  'aria-hidden': true,
};

export const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...strokeIconProps}>
    <path d="M4 6L8 10L12 6" />
  </svg>
);

export const ChevronRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...fillIconProps}>
    <path d="m12.536 4.254-1.43 1.43a.867.867 0 0 0 0 1.227L24.163 20 11.105 33.089a.867.867 0 0 0 0 1.226l1.431 1.431a.867.867 0 0 0 1.227 0l15.132-15.133a.867.867 0 0 0 0-1.226L13.763 4.254a.867.867 0 0 0-1.227 0Z" />
  </svg>
);

export const CheckmarkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...strokeIconProps}>
    <path d="M3 8L6.5 11.5L13 4.5" />
  </svg>
);

export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...strokeIconProps}>
    <path d="M4 4L12 12M12 4L4 12" />
  </svg>
);

export const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...strokeIconProps}>
    <path d="M1.5 8C3 5 5.5 3.5 8 3.5C10.5 3.5 13 5 14.5 8C13 11 10.5 12.5 8 12.5C5.5 12.5 3 11 1.5 8Z" />
    <circle cx="8" cy="8" r="2" />
  </svg>
);

export const EyeOffIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...strokeIconProps}>
    <path d="M2 2L14 14" />
    <path d="M6.2 6.2C5.6 6.6 5.2 7.3 5.2 8C5.2 9.5 6.5 10.8 8 10.8C8.7 10.8 9.4 10.4 9.8 9.8" />
    <path d="M3 10.5C2 9.7 1.5 8.8 1.5 8C3 5 5.5 3.5 8 3.5C8.6 3.5 9.2 3.6 9.8 3.8" />
    <path d="M12.5 5C13.5 5.8 14.2 6.8 14.5 8C13 11 10.5 12.5 8 12.5C7.4 12.5 6.8 12.4 6.2 12.2" />
  </svg>
);

export const ArrowUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...fillIconProps}>
    <path d="M21.4038 2.59464C21.0341 2.21696 20.5359 2 20.0056 2C19.4752 2 18.977 2.21696 18.6073 2.59464L5.10734 16.7375C4.36805 17.5089 4.4002 18.7304 5.17163 19.4616C5.94305 20.1929 7.16448 20.1687 7.89573 19.3973L18.077 8.74196V36.0714C18.077 37.1402 18.9368 38 20.0056 38C21.0743 38 21.9341 37.1402 21.9341 36.0714V8.74196L32.1073 19.4054C32.8466 20.1768 34.06 20.2009 34.8314 19.4696C35.6029 18.7384 35.627 17.517 34.8957 16.7455L21.3957 2.60268L21.4038 2.59464Z" />
  </svg>
);

export const ArrowDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...fillIconProps}>
    <path d="M18.5962 37.4054C18.9578 37.783 19.4641 38 19.9944 38C20.5248 38 21.023 37.783 21.3926 37.4054L34.8926 23.2625C35.6319 22.4911 35.5998 21.2696 34.8283 20.5384C34.0569 19.8071 32.8355 19.8312 32.1042 20.6027L21.923 31.258V3.92857C21.923 2.85982 21.0632 2 19.9944 2C18.9257 2 18.0658 2.85982 18.0658 3.92857V31.258L7.89263 20.5946C7.15334 19.8232 5.93995 19.7991 5.16852 20.5304C4.39709 21.2616 4.37299 22.483 5.10424 23.2545L18.6042 37.3973L18.5962 37.4054Z" />
  </svg>
);

export const ExpandIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...strokeIconProps}>
    <path d="M3 6V3H6" />
    <path d="M10 3H13V6" />
    <path d="M13 10V13H10" />
    <path d="M6 13H3V10" />
  </svg>
);

export const CompressIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...strokeIconProps}>
    <path d="M6 3V6H3" />
    <path d="M13 6H10V3" />
    <path d="M10 13V10H13" />
    <path d="M3 10H6V13" />
  </svg>
);

export const EllipsisIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" {...strokeIconProps}>
    <circle cx="3.5" cy="8" r="1" fill="currentColor" stroke="none" />
    <circle cx="8" cy="8" r="1" fill="currentColor" stroke="none" />
    <circle cx="12.5" cy="8" r="1" fill="currentColor" stroke="none" />
  </svg>
);
